import React, { useEffect, useState } from 'react';
import './CookieConsent.css';

const CONSENT_KEY = 'velospect_cookie_consent';

function CookieConsent({ darkMode = true }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.localStorage) {
      return;
    }

    try {
      const stored = window.localStorage.getItem(CONSENT_KEY);
      if (!stored) {
        setVisible(true);
      }
    } catch (error) {
      // localStorage might be blocked, still surface the banner
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
      try {
        window.localStorage.setItem(
          CONSENT_KEY,
          JSON.stringify({
            accepted: true,
            timestamp: new Date().toISOString(),
          })
        );
      } catch (error) {
        // Ignore storage failures; banner will reappear on next visit
      }
    }
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      className={`cookie-consent ${
        darkMode ? 'cookie-consent--dark' : 'cookie-consent--light'
      }`}
      role="dialog"
      aria-live="polite"
      aria-label="Cookie usage notice"
    >
      <div className="cookie-consent__content">
        <h4 className="cookie-consent__title">We use one essential cookie</h4>
        <p className="cookie-consent__description">
          Frame-Book stores a single secure session cookie so you can stay signed
          in. It is strictly necessary for authentication and never used for
          tracking or advertising.
        </p>
      </div>
      <div className="cookie-consent__actions">
        <button
          type="button"
          onClick={handleAccept}
          className="btn btn-primary cookie-consent__button"
        >
          Got it
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;


